import Vue from '/builds/gitlab/gitlab-ee/app/assets/javascripts/lib/utils/vue3compat/vue.js?vue3';
import VueApollo from '/builds/gitlab/gitlab-ee/app/assets/javascripts/lib/utils/vue3compat/vue_apollo.js?vue3';
import { initVueApp } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/lib/utils/vue3compat/init_vue_app.js?vue3';
import createDefaultClient from '/builds/gitlab/gitlab-ee/app/assets/javascripts/lib/graphql.js?vue3';
import { convertObjectPropsToCamelCase } from '~/lib/utils/common_utils';
import ReleaseShowApp from '/builds/gitlab/gitlab-ee/app/assets/javascripts/releases/components/app_show.vue?vue3';

Vue.use(VueApollo);

const apolloProvider = new VueApollo({
  defaultClient: createDefaultClient(),
});

export default () => {
  const el = document.getElementById('js-show-release-page');

  if (!el) return false;

  const { projectPath, tagName, deployments } = el.dataset;

  let parsedDeployments;

  try {
    parsedDeployments = JSON.parse(deployments);
  } catch {
    parsedDeployments = {};
  }

  return initVueApp({
    el,
    name: 'ReleaseShowAppRoot',
    apolloProvider,
    provide: {
      projectPath,
      tagName,
    },
    component: ReleaseShowApp,
    props: {
      deployments: convertObjectPropsToCamelCase(parsedDeployments, { deep: true }),
    },
  });
};
